<template>
    <div id="sidebar-wrapper" class="full-height sidebar--toggleable" v-bind:class="{active: showSidebar}">
        <div class="sidebar--toggle" v-on:click="toggleSidebar"><i class="icon ion-md-more"></i></div>
        <div class="sidebar sidebar-left full-height">
            <h2><i class="icon ion-md-settings"></i> Organisation Settings</h2>
            <ul>
                <li>
                    <router-link :to="{ name: 'settings' }">General Settings</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'settings-users' }">Manage Team</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'settings-sso' }">Single Sign On</router-link>
                </li>        
            </ul>
            <h2><i class="icon ion-md-color-palette"></i> Appearance</h2>
            <ul>
                <li>
                    <router-link :to="{ name: 'settings-menu' }">Navigation</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'settings-login' }">Login Page</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                showSidebar: false,
            }
        },
        mounted() {
            // If there is no loaded post then show sidebar
            let count = document.getElementById('content-wrapper').firstChild;
            if (!count) {
                this.showSidebar = true;
            }
        },
        methods: {
            toggleSidebar() {
                this.showSidebar = !this.showSidebar;
                console.log('toggleSidebar() called');
            },
        }
    }
</script>